import reduceReducers from "reduce-reducers";

import { SIDELOADED_BUSINESS_SET } from "constants/actionTypes";

import { defaultInitialState, offlineCrudReducer } from "lib/reducers";
import { deserializeSideLoadedDataSet } from "lib/serializers/sideLoadedDataSets";

const initialState = {
  ...defaultInitialState,
  isUploading: false,
  uploadError: null,
  isSavingMapping: false,
  mappingError: null,
};

const crudReducer = offlineCrudReducer(SIDELOADED_BUSINESS_SET, {
  deserializer: deserializeSideLoadedDataSet,
  // So a FETCH_BULK.RESET restores the upload fields too, rather than dropping
  // them back to the bare slice shape.
  initialState,
});

const uploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIDELOADED_BUSINESS_SET.UPLOAD.REQUEST:
      return { ...state, isUploading: true, uploadError: null };
    case SIDELOADED_BUSINESS_SET.UPLOAD.SUCCESS:
      return { ...state, isUploading: false, uploadError: null };
    case SIDELOADED_BUSINESS_SET.UPLOAD.FAILURE:
      return { ...state, isUploading: false, uploadError: action.errorMessage };
    // Only the error - an upload in flight keeps its spinner.
    case SIDELOADED_BUSINESS_SET.UPLOAD.RESET_ERROR:
      return { ...state, uploadError: null };
    case SIDELOADED_BUSINESS_SET.SAVE_MAPPING.REQUEST:
      return { ...state, isSavingMapping: true, mappingError: null };
    case SIDELOADED_BUSINESS_SET.SAVE_MAPPING.SUCCESS:
      return { ...state, isSavingMapping: false, mappingError: null };
    case SIDELOADED_BUSINESS_SET.SAVE_MAPPING.FAILURE:
      return {
        ...state,
        isSavingMapping: false,
        mappingError: action.errorMessage,
      };
    case SIDELOADED_BUSINESS_SET.SAVE_MAPPING.RESET_ERROR:
      return { ...state, mappingError: null };
    default:
      return state;
  }
};

const sideLoadedDataSets = reduceReducers(
  initialState,
  crudReducer,
  uploadReducer,
);

export default sideLoadedDataSets;
